/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const checkout = {
  checkout: {
    backToCart: 'Voltar ao carrinho',
  },
  checkoutProgress: {
    label: 'Progresso do processo de pagamento',
    deliveryAddress: 'Endereço de entrega',
    deliveryMode: 'Modo de entrega',
    paymentDetails: 'Pagamento',
    reviewOrder: 'Revisão',
  },
  checkoutAddress: {
    shippingAddress: 'Endereço de entrega',
    selectYourDeliveryAddress: 'Selecione seu endereço de entrega',
    defaultDeliveryAddress: 'Endereço de entrega padrão',
    addNewAddress: 'Adicionar novo endereço',
    shipToThisAddress: 'Enviar para este endereço',
    deliveryAddressSelected: 'Endereço de entrega selecionado',
  },
  checkoutMode: {
    deliveryMethod: 'Método de entrega',
    standardDelivery: 'Entrega padrão',
    premiumDelivery: 'Entrega Premium',
    deliveryEntries: 'Itens a serem enviados',
  },
  checkoutReview: {
    review: 'Revisão',
    orderItems: 'Itens do pedido',
    confirmThatRead: 'Confirmo que li e concordo com o',
    placeOrder: 'Fazer pedido',
    termsAndConditions: 'Termos e Condições',
    editDeliveryAddressDetails:
      'Edite os detalhes do endereço de entrega, abra a página Endereço de entrega',
    editPagamentoDetails: 'Edite os detalhes de pagamento e abra a página Detalhes de pagamento',
    editPagamentoType: 'Edite sua forma de pagamento, abra a página Forma de pagamento',
    editDeliveryMode: 'Edite o modo de entrega, abra a página Modo de entrega',
    orderInProcess: 'O pedido está em andamento. Esperar.',
  },
  checkoutOrderConfirmation: {
    confirmationOfOrder: 'Confirmação do pedido:',
    thankYou: 'Obrigado pelo seu pedido!',
    invoiceHasBeenSentByEmail:
      'Uma confirmação do pedido foi enviada por e-mail. Você deve obtê-lo em breve.',
    orderItems: 'Itens do pedido',
    orderPlacedSuccessfully: 'Pedido feito com sucesso',
    createAccount: 'Criar uma conta?',
    createAccountForNext:
      'Crie uma conta para <{{{email}}> para um pagamento mais rápido na sua próxima visita.',
  },
};
